/**
 * Returns a new array with the replaced element.
 *
 * @param {Array<object>} elements - Array of elements that needs to have an element replaced
 * @param {object} element - Element that will be used to replace its matching element
 * @param {function} predicate - Function used to find the matching element, taking two elements as parameters and returning a boolean. Defaults to `element._id` equality check.
 * @returns {Array<object>} Returns a new array with the element replaced, or an empty array if the element could not be found.
 */
export function replaceElement(elements, element, predicate = (a, b) => a._id === b._id) {
    const index = elements.findIndex((i) => predicate(i, element));

    if (index < 0) {
        return [];
    }

    return [...elements.slice(0, index), element, ...elements.slice(index + 1)];
}
